import * as R from 'ramda'
import moment from 'moment'
import breakdown from './breakdown'
import incomeStatement from './incomeStatement'
import taxDeferal from './taxDeferal'
import investment from './investment'
import { equityProperty } from './equity'
import { parsePeriod } from 'utils/stuff'

export default (properties, transactions, leases, listings, history, taxBraket, startMarketDateByPropertyID, period) => {
	let parsedPeriod = period == 'projected' ? parsePeriod(moment().year()): parsePeriod(period)

	let netIncome = incomeStatement(transactions, properties, leases, listings, startMarketDateByPropertyID, period).netIncome
	let currBreakdown = breakdown(properties, parsedPeriod.to)
	let startBreakDown = breakdown(properties, parsedPeriod.from)
	let currTaxDeferal = taxDeferal(transactions, properties, leases, listings, taxBraket, startMarketDateByPropertyID, period)
	let capitalGain = equityProperty(history, properties)
	let currInvestment = investment(properties)

	let res = R.map(property => {
		let startPeriod = moment(parsedPeriod.from) > moment(startMarketDateByPropertyID[property._id]) ? parsedPeriod.from : startMarketDateByPropertyID[property._id]
		let fullDays = period == 'projected' ? 365 : moment(parsedPeriod.to).diff(moment(startPeriod), 'days') + 1

		let propertyCurrLoanPaid = currBreakdown[property._id] && currBreakdown[property._id].total && currBreakdown[property._id].total.principle || 0
		let propertyStartLoanPaid = startBreakDown[property._id] && startBreakDown[property._id].total && startBreakDown[property._id].total.principle || 0

		let propertyNetIncome = netIncome[property._id] || 0
		  , propertyLoanPaid = propertyCurrLoanPaid - propertyStartLoanPaid
		  , propertyTaxDeferal = currTaxDeferal[property._id] || 0
		  , propertyGain = capitalGain[property._id] && capitalGain[property._id].gain || 0
		  , propertyInvestment = currInvestment[property._id] || 0
		return (propertyNetIncome + propertyLoanPaid + propertyTaxDeferal + propertyGain) * 365 / fullDays / propertyInvestment * 100
	})(properties)

	let totalCurrLoanPaid = currBreakdown.total && currBreakdown.total.total && currBreakdown.total.total.principle || 0
	let totalStartLoanPaid = startBreakDown.total && startBreakDown.total.total && startBreakDown.total.total.principle || 0

	let totalNetIncome = netIncome.total || 0
	  , totalLoanPaid = totalCurrLoanPaid - totalStartLoanPaid
	  , totalTaxDeferal = currTaxDeferal.total || 0
	  , totalGain = capitalGain.total && capitalGain.total.gain || 0
	  , totalInvestment = currInvestment.total || 0
	let fullDays = moment(parsedPeriod.to).diff(moment(parsedPeriod.from), 'days')

	res.total = (totalNetIncome + totalLoanPaid + totalTaxDeferal + totalGain) * 365 / fullDays / totalInvestment * 100

	return res
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/roiWithGain.js